"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toggle = (modalKey, isOpen) => ({ getState, setState }) => {
    const modalState = getState();
    if (typeof isOpen !== 'boolean') {
        setState({
            [modalKey]: { isOpen: !modalState[modalKey].isOpen }
        });
    }
    else {
        setState({
            [modalKey]: {
                isOpen
            }
        });
    }
};
exports.default = toggle;
